module.exports = function (fox, v) {
	var alias = 'postalcode';
	var Validator_Postalcode = function() {
		this._alias = alias;
	};

	v._.registerHelper(alias, fox.extend(Validator_Postalcode, fox.mixin({
		_regexpGroups: {
			0: /^[\w\W]*$/i,
			1: [/^\d{4}$/i, 'NNNN'],
			2: [/^\d{5}$/i, 'NNNNN'],
			3: [/^[a-zA-Z]{4}\s?\d[a-zA-Z]{2}$/i, 'AAAA[ ]NAA'],
			4: [/^\d{6}$/i, 'NNNNNN'],
			5: [/^\d{3}$/i, 'NNN'],
			6: [/^\d{3}\-?\d{4}$/i, 'NNN[-]NNNN'],
			7: [/^\d{4,5}$/i, 'NNNN[N]'],
			8: [/^\d{3}\s?\d{2}$/i, 'NNN[ ]NN'],
			9: [/^\d{2}$/i, 'NN'],
			10: [/^\d{5}(\-\d{4}|)$/i, 'NNNNN[-NNNN]'],
			11: [/^\d{3}\-?\s?\d{3}$/i, 'NNN[- ]NNN'],
			12: [/^[a-zA-Z]{2}\-?\s?\d{4}$/i, 'AA[- ]NNNN'],
			13: [/^[a-zA-Z]{2}\-?\s?\d{5}$/i, 'AA[- ]NNNNN'],
			14: [/^[a-zA-Z]{2}\d\d?\s?\d[a-zA-Z]{2}$/i, 'AAN[N ]AA'],
			15: [/^\d{7}$/i, 'NNNNNNN']
		},
		_countries: {
			'AC': 3, 'AE': 0, 'AF': 1, 'AG': 0, 'AL': 1, 'AM': 1, 'AO': 0, 'AT': 1, 'AU': 1, 'AW': 0, 'AX': 2, 'AZ': 12,
			'BA': 2, 'BB': 13, 'BD': 1, 'BE': 1, 'BF': 0, 'BG': 1, 'BI': 0, 'BJ': 0, 'BL': 2, 'BN': 12, 'BO': 1, 'BQ': 0, 'BS': 0, 'BT': 5, 'BW': 0, 'BY': 4, 'BZ': 0,
			'CC': 1, 'CD': 0, 'CF': 0, 'CG': 0, 'CH': 1, 'CI': 0, 'CK': 0, 'CL': 6, 'CM': 0, 'CN': 4, 'CO': 4, 'CR': 7, 'CU': 2, 'CV': 1, 'CW': 0, 'CX': 1, 'CY': 1, 'CZ': 8,
			'DE': 2, 'DJ': 0, 'DK': 1, 'DM': 0, 'DO': 2, 'DZ': 2,
			'EC': 4, 'EE': 2, 'EG': 2, 'ER': 0, 'ES': 2, 'ET': 1,
			'FI': 2, 'FJ': 0, 'FK': 3, 'FM': 2, 'FO': 5, 'FR': 2,
			'GD': 0, 'GE': 1, 'GF': 2, 'GG': 14, 'GH': 0, 'GL': 1, 'GM': 0, 'GN': 0, 'GP': 2, 'GQ': 0, 'GR': 8, 'GT': 2, 'GU': 2, 'GW': 1, 'GY': 0,
			'HK': 0, 'HM': 1, 'HN': 2, 'HR': 2, 'HT': 1, 'HU': 1,
			'ID': 2, 'IE': 0, 'IL': 15, 'IM': 14, 'IN': 11, 'IO': 3, 'IQ': 2, 'IS': 5, 'IT': 2,
			'JM': 9, 'JO': 2, 'JP': 6,
			'KE': 2, 'KG': 4, 'KH': 2, 'KI': 0, 'KM': 0, 'KN': 0, 'KP': 0, 'KR': 11, 'KW': 2, 'KY': 12, 'KZ': 4,
			'LA': 2, 'LC': 0, 'LI': 1, 'LK': 2, 'LR': 1, 'LS': 5, 'LT': 13, 'LU': 1, 'LV': 12, 'LY': 2,
			'MA': 2, 'MD': 12, 'ME': 2, 'MF': 2, 'MG': 5, 'MH': 2, 'MK': 1, 'ML': 0, 'MM': 2, 'MN': 2, 'MO': 0, 'MP': 2, 'MQ': 2, 'MR': 0, 'MS': 0, 'MU': 0, 'MV': 7, 'MW': 0, 'MX': 2, 'MY': 2, 'MZ': 1,
			'NA': 2, 'NC': 2, 'NE': 1, 'NF': 1, 'NG': 4, 'NI': 2, 'NO': 1, 'NP': 2, 'NR': 0, 'NU': 0, 'NZ': 1,
			'OM': 5,
			'PA': 4, 'PE': 2, 'PF': 2, 'PG': 5, 'PH': 1, 'PK': 2, 'PM': 2, 'PN': 3, 'PR': 2, 'PW': 2, 'PY': 1,
			'QA': 0,
			'RE': 2, 'RO': 4, 'RS': 2, 'RS': 2, 'RU': 4,
			'SA': 10, 'SB': 0, 'SC': 0, 'SD': 2, 'SE': 8, 'SG': 9, 'SK': 8, 'SL': 0, 'SM': 2, 'SN': 2, 'SO': 0, 'SR': 0, 'ST': 0, 'SX': 0, 'SY': 0,
			'TD': 2, 'TF': 0, 'TG': 0, 'TH': 2, 'TJ': 4, 'TK': 0, 'TL': 0, 'TM': 4, 'TN': 1, 'TO': 0, 'TR': 2, 'TT': 4, 'TV': 0, 'TW': 2, 'TZ': 0,
			'UA': 2, 'UG': 0, 'US': 10, 'UY': 2, 'UZ': 11,
			'VC': 12, 'VG': 12, 'VI': 2, 'VN': 4, 'VU': 0,
			'WF': 2,
			'XK': 2,
			'YE': 0, 'YT': 2,
			'ZA': 1, 'ZM': 2, 'ZW': 0,
			'AD': [/^AD\d{3}$/i, 'AANNN'], 'AI': [/^AI\-2640$/i, 'AI-2640'], 'AR': [/^[a-zA-Z]\d{4}[a-zA-Z]{3}$/i, 'ANNNNAAA'], 'AS': [/^\d{5}(\-\d{4,6}|)$/i, 'NNNNN[-NNNN[NN]]'],
			'BH': [/^\d{3,4}$/i, 'NNN[N]'], 'BM': [/^[a-zA-Z]{2}\s?(\d{2}|[a-zA-Z]{2})$/i, 'AA[ ]NN or AA[ ]AA)'], 'BR': [/^\d{5}-\d{3}$/i, 'NNNNN-NNN'],
			'CA': [/^([a-zA-Z]\d[a-zA-Z]\s+\d[a-zA-Z]\d)$/i, 'ANA NAN'],
			'GA': [/^\d{2}\s?\w*\s?\d{2}$/i, 'NN[ ]city[ ]NN'], 'GB': [/^[a-zA-Z]{1,2}\d[a-zA-Z0-9]?\s?\d[a-zA-Z]{2}$/i, 'A(A)N(A/N)NAA or A[A]N[A/N] NAA'], 'GI': [/GX11\s1AA/i, 'GX11 1AA'], 'GS': [/^SIQQ\s?1ZZ$/i, 'SIQQ 1ZZ'],
			'IR': [/^\d{5}\-\d{5}$/i, 'NNNNN-NNNNN'], 'JE': [/^JE\d\s?\d[a-zA-Z]{2}$/i, 'AAN[ ]NAA'],
			'LB': [/^\d{4}\s?\d{4}$/i, 'NNNN[ ]NNNN'],
			'MC': [/^980\d{2}$/i, '980NN'], 'MT': [/^[a-zA-Z]{3}\s?\d{4}$/i, 'AAA[ ]NNNN'],
			'NL': [/^\d{4}\s?[a-zA-Z]{2}$/i, 'NNNN[ ]AA'],
			'PL': [/^\d{2}\-?\d{3}$/i, 'NN-NNN'], 'PT': [/^\d{4}(\-|\s)\d{3}$/i, 'NNNN[- ]NNN'],
			/*'SH': [/^STHL\s?1ZZ$/i, 'STHL 1ZZ'],*/ 'SH': [/^TDCU\s?1ZZ$/i, 'TDCU 1ZZ'], 'SI': [/^(SI\s?|)\d{4}$/i, '[AA]NNNN'], 'SV': [/^01101$/i, '01101'], 'SZ': [/^[a-zA-Z]\d{3}$/i, 'ANNN'],
			'TC': [/^TKCA\s?1ZZ$/i, 'TKCA 1ZZ'],
			'VA': [/^00120$/i, '00120'], 'VE': [/^\d{4}(\s?[a-zA-Z]|)$/i, 'NNNN[ A]']
		},
		_regexp: null,

		_init: function() {
			if (this._options.country && this._countries[this._options.country] && this._regexpGroups[this._countries[this._options.country]]) {
				this._regexp = this._regexpGroups[this._countries[this._options.country]];
			}
		},

		validate: function(country) {
			var message = 'Wrong postal code';
			var regexp = null;

			if (country && fox.isSet(this._countries[country])) {
				if (fox.isNumeric(this._countries[country])) {
					check = this._regexpGroups[this._countries[country]];
				} else {
					check = this._countries[country];
				}

				if (fox.isArray(check)) {
					message += ' [format: ' + check[1] + ']';
					regexp = check[0];
				} else {
					regexp = check;
				}

				this.setMessage(message);
				return regexp.test(this._value);
			} else if (this._regexp) {
				return this._regexp.test(this._value);
			} else {
				return false;
			}
		}
	}, v._.getBaseHelper()), null, 'Validator_Postalcode'));
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/validator/validators/postalcode.js
// module id = 235
// module chunks = 0